import http from './http-service'
import config from '../config/constant'
import { store } from '../store'
import { SET_ACC_CLASS } from '../utils/constants'

export const getTenorLists = async (data) => {
  try {
    const reqParams = {
      accountNo: data.accountNo,
      brnCode: data.brnCode,
      requestId: 'TERMDEPOSITINTERESTRATES',
    }
    const response = await http.post(config.portfolio.tdInterestRatesList, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const createTermDeposit = async (data) => {
  try {
    let autoRollFlag = ''
    let rolloverType = ''
    if (data?.autoRenewal === 'CLOSE_ON_MATURITY') {
      autoRollFlag = 'Y'
      rolloverType = 'N'
    } else {
      autoRollFlag = 'N'
      rolloverType = data?.principle ? 'Y' : 'N'
    }
    const reqParams = {
      ...data,
      module: "TERMDEPOSIT",
      requestId: "INITIATETDREQUEST",
      rolloverType: rolloverType,
      autoRollFlag: autoRollFlag,
    }
    const response = await http.post(config.portfolio.tdCreateinitVerify, reqParams)
    //store.dispatch({ type: SET_ACC_CLASS, payload: response.data.accClass })
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const confirmTermDeposit = async (data) => {
  try {
    let autoRollFlag = ''
    let rolloverType = ''
    if (data?.autoRenewal === 'CLOSE_ON_MATURITY') {
      autoRollFlag = 'Y'
      rolloverType = 'N'
    } else {
      autoRollFlag = 'N'
      rolloverType = data?.principle ? 'Y' : 'N'
    }
    const reqParams = {
      ...data,
      module: "TERMDEPOSIT",
      requestId: 'INITIATETDREQUEST',
      rolloverType: rolloverType,
      autoRollFlag: autoRollFlag,
      principle:''
    }

    const response = await http.post(config.portfolio.tdCreateinitConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const DepositeService = {
  getTenorLists,
  createTermDeposit,
  confirmTermDeposit,
}

export default DepositeService
